import { lazy, type FC } from 'react';
import { useParams } from 'react-router-dom';
import type { Uuid } from 'src/apis/api-utilities';
import { useNotificationDetails } from 'src/apis/notification-service/use-notification-details';
import { type NotificationServiceRequest } from 'src/apis/notification-service/use-notification-service-root';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { Forbidden } from 'src/utils/errors';

const Page = lazy(() => import('./page'));

export const NotificationDetails: FC<{
  notificationService: Successful<NotificationServiceRequest>;
}> = ({ notificationService }) => {
  if (!notificationService.response.data._links.getNotification)
    throw new Forbidden();

  const { notificationId } = useParams<{ notificationId: Uuid }>();
  const notificationDetails = useNotificationDetails({
    notificationService,
    notificationId,
  });

  if (!notificationDetails.response) return <PageSpinner />;
  return <Page notificationDetails={notificationDetails} />;
};
